module.exports = __webpack_public_path__ + "img/avatar2.d53abc30.png";